import * as React from "react";
import { useHistory } from "react-router-dom";
import { Draggable } from "react-beautiful-dnd";
import { RiskTemplate } from "types";

interface Props {
  template: RiskTemplate;
  index: number;
}

export const RiskGroupingTemplateMemberRow: React.FC<Props> = ({
  template,
  index,
}) => {
  const history = useHistory();
  const name = template.payload.blueprint_name || template.payload.id;

  return (
    <Draggable key={template.crn} draggableId={template.crn} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className="flex items-center my-2 cursor-pointer hover:bg-gray-100 rounded px-2 py-1"
          onClick={() => history.push(`/risk-templates/${template.crn}`)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-5 h-5 mr-2 text-gray-400 flex-shrink-0"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
            />
          </svg>
          <span className="text-sm text-gray-700">{name}</span>
        </div>
      )}
    </Draggable>
  );
};
